import React, { useEffect, useState } from "react";
import { Input } from "../../Input/Input";
import PropTypes from "prop-types";
import { TextWithIcon } from "../TextWithIcon/TextWithIcon";
import "./DropDown.scss";
import { Menu } from "../../Menu/Menu";
import { ICONPATH } from "../../../Constant";

export const DropDown = ({ toggle }) => {
  let [show, setShow] = useState(true);
  toggle = show;

  return (
    <div
      className="es-header-dropdown"
      style={{ transform: toggle ? "translateY(0)" : "translateY(-200%)" }}
    >
      <Input placeholder="Search" type="search" width="80%" />

      <TextWithIcon icon={ICONPATH.userIcon} label={"Profile"} link="#" />
      <TextWithIcon icon={ICONPATH.helpCircleIcon} label={"Help"} />
      <TextWithIcon icon={ICONPATH.cartIcon} label={"Cart"} />
      <Menu />
    </div>
  );
};

DropDown.propTypes = {
  toggle: PropTypes.bool.isRequired,
};
DropDown.defaultProps = {
  toggle: false,
};
